import { useTranslation } from "react-i18next";
import { usePremiumModal } from "../hooks/usePremiumModal";
import {
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "~/components/ui/dialog";

export function PremiumModal() {
  const { t } = useTranslation();
  const { telegramWidgetRef, authError } = usePremiumModal();

  return (
    <DialogContent>
      <DialogHeader>
        <DialogTitle>{t("premiumModal.title")}</DialogTitle>
        <DialogDescription>{t("premiumModal.description")}</DialogDescription>
      </DialogHeader>
      <div ref={telegramWidgetRef} className="flex justify-center" />
      {authError && (
        <p className="text-destructive text-sm text-center">{authError}</p>
      )}
    </DialogContent>
  );
}
